export default {
  common: {
    ctaStartTrial: 'Commencer',
    ctaBookDemo: 'Réserver une démo',
    noCreditCard: 'Commencez en quelques minutes. Plans dès 100 $ par mois pour 10 chauffeurs.',
    faqTitle: 'Questions fréquentes',
    breadcrumb: {
      home: 'Accueil',
      resources: 'Ressources',
      features: 'Fonctionnalités',
      blog: 'Blog',
      caseStudies: 'Études de cas',
    },
  },
  nav: {
    builtFor: 'Par secteur',
    features: 'Fonctionnalités',
    resources: 'Ressources',
    howItWorks: 'Comment ça marche',
    pricing: 'Tarifs',
    partners: 'Partenaires',
    integrations: 'Intégrations',
    contact: 'Contact',
    login: 'Connexion',
    getStarted: 'Commencer',
    mobileLanguage: 'Langue',
    comingSoon: 'Bientôt disponible',
    panels: {
      builtFor: {
        title: 'Solutions par secteur',
        subtitle: 'Gestion de flotte adaptée aux besoins de votre secteur.',
        viewAll: 'Voir tous les secteurs',
        useCases: 'Secteurs',
        useCasesSub: 'Regroupés par domaine — choisissez ou tout voir.',
        groupFoodHealth: 'Alimentaire, santé & supermarchés',
        groupRetailCommerce: 'Retail, e‑commerce & distribution',
        groupLogisticsField: 'Logistique & terrain',
        industryBenefitsTitle: 'Bénéfices par secteur',
        industryBenefitsSub: 'Résultats prouvés dans tous les secteurs',
        quickAccessTitle: 'Accès rapide',
        successStory: 'Cas client',
        successStoryTitle: 'Comment les entreprises réduisent leurs coûts de livraison de 20–30 %',
        successStoryDesc: 'Découvrez comment les leaders de la logistique utilisent Geofleet pour optimiser leurs opérations.',
        readCaseStudy: 'Lire l\'étude de cas',
        readyToOptimize: 'Prêt à optimiser les opérations de votre secteur ?',
        getIndustryDemo: 'Demander une démo secteur',
      },
      features: {
        title: 'Fonctionnalités de la plateforme',
        subtitle: 'Outils IA pour la livraison, le routage, la preuve de livraison et les opérations flotte.',
        viewAll: 'Voir toutes les fonctionnalités',
        trackingDelivery: 'Suivi et livraison',
        trackingDeliverySub: 'Outils clients et chauffeurs',
        operationsInsights: 'Opérations et insights',
        operationsInsightsSub: 'Automatisation, finance et analytics',
        aiFirst: 'IA d\'abord',
        everyFeaturePowered: 'Chaque fonctionnalité propulsée par l\'IA',
        automatingDecisions: 'Automatisation des décisions, prédiction des résultats et apprentissage à partir de vos données.',
        startFreeTrial: 'Commencer',
        getDemo: 'Réserver une démo',
        readyToAutomate: 'Prêt à automatiser vos opérations de livraison ?',
      },
      resources: {
        title: 'Ressources',
        subtitle: 'Cas clients, guides et support.',
        viewAll: 'Voir toutes les ressources',
        learning: 'Formation',
        successStories: 'Cas clients',
        support: 'Support',
        latestReport: 'Guide',
        lastMile2026: 'Comment fonctionne Geofleet',
        lastMileDesc: 'Six étapes de la commande à la preuve de livraison.',
        readReport: 'Lire le guide',
        needHelp: 'Besoin d\'aide pour démarrer ?',
        contactExperts: 'Contacter nos experts',
      },
    },
    items: {
      builtFor: {
        restaurants: { label: 'Restaurants et QSR', description: 'Livrez plus vite, améliorez le service' },
        pharmacies: { label: 'Pharmacies', description: 'Livraison de prescriptions fiable' },
        retail: { label: 'Retail', description: 'Simplifiez les livraisons retail' },
        ecommerce: { label: 'E-commerce', description: 'Scalez votre boutique en ligne' },
        couriers: { label: 'Courriers et logistique', description: 'Gérez chauffeurs et tournées' },
        laundry: { label: 'Laverie et pressing', description: 'Enlèvement et livraison' },
        flowers: { label: 'Fleurs et cadeaux', description: 'Livraisons sensibles au délai' },
        water: { label: 'Eau à domicile', description: 'Gestion de tournées récurrentes' },
        fuel: { label: 'Carburant et gaz', description: 'Logistique carburant à la demande' },
        manufacturing: { label: 'Manufacturing', description: 'Dernier kilomètre supply chain' },
        grocery: { label: 'Supermarchés', description: 'Créneaux, routes denses, substitutions' },
        'b2b-distribution': { label: 'B2B & grossistes', description: 'Logiciel livraison distribution' },
        'medical-supplies': { label: 'Médical & labos', description: 'Prélèvements, kits, créneaux' },
        'field-service': { label: 'Service terrain', description: 'RDV, pièces, camions' },
        'building-supplies': { label: 'BTP & volumineux', description: 'Lourds, créneaux, POD' },
        'automotive-parts': { label: 'Pièces auto', description: 'Jour même & réseaux concessionnaires' },
        'contract-logistics': { label: '3PL & contrat', description: 'SLA multi-expéditeurs & portails' },
      },
      features: {
        brandedTracking: { label: 'URL de suivi avec marque', description: 'Pages de suivi personnalisées pour les clients' },
        routePlanner: { label: 'Planificateur de tournées', description: 'Routage multi-étapes optimisé par l\'IA' },
        aiAgents: { label: 'Agents IA', description: 'Automatisez le dispatch et les opérations' },
        proofOfDelivery: { label: 'Preuve de livraison', description: 'Photos, signatures et horodatage' },
        autoAllocation: { label: 'Allocation automatique', description: 'Des agents IA affectent les commandes aux chauffeurs' },
        cashManagement: { label: 'Gestion de la caisse', description: 'Suivi des paiements contre remboursement' },
        reportsAnalytics: { label: 'Rapports et analyses', description: 'Insights performance propulsés par l\'IA' },
        driverApp: { label: 'App chauffeur', description: 'Suivi en temps réel et outils' },
      },
      resources: {
        caseStudies: { label: 'Études de cas', description: 'Histoires de clients' },
        blog: { label: 'Blog', description: 'Tendances et conseils par secteur' },
        roiCalculator: {
          label: 'Calculateur ROI',
          description: 'Estimez les gains liés à moins de retards et une meilleure utilisation de la flotte',
        },
        whitepapers: { label: 'Whitepapers', description: 'Recherche et guides en profondeur' },
        blogArticles: { label: 'Blog et articles', description: 'Tendances et bonnes pratiques' },
        webinars: { label: 'Webinars et événements', description: 'Sessions live et enregistrements' },
        customerSuccess: { label: 'Succès client', description: 'Comment les entreprises atteignent le ROI' },
        helpCenter: { label: 'Centre d\'aide' },
        apiDocs: { label: 'Documentation API' },
      },
      industryBenefits: {
        fasterDeliveries: { value: '30%', label: 'Livraisons plus rapides', description: 'Les tournées optimisées réduisent les délais.' },
        costReduction: { value: '20–30%', label: 'Réduction des coûts', description: 'Moins de carburant et de coûts opérationnels.' },
      },
      quickAccess: {
        helpCenter: 'Centre d\'aide',
        contactSupport: 'Contacter le support',
      },
    },
  },
};
